module.exports = [{
      plugin: require('../node_modules/.pnpm/@vp+gatsby-plugin-static-site@1.5.68_gatsby@5.16.1_@types+node@24.13.3_babel-eslint@10._72b3567de8190379db0ad0b1eb247a49/node_modules/@vp/gatsby-plugin-static-site/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/@vp+digital-gatsby-plugin-rollbar-provider@0.18.0_e50f920a1e2782ae3d4426b50f760f66/node_modules/@vp/digital-gatsby-plugin-rollbar-provider/gatsby-browser.js'),
      options: {"plugins":[],"accessToken":"43c47eba7c1a491185f8aa37d5153626","captureUncaught":true,"captureUnhandledRejections":true,"payload":{"environment":"Staging","client":{"javascript":{"code_version":"ba78fb5","source_map_enabled":true,"guess_uncaught_frames":true}}}},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-use-query-params-v2@2.0.0_gatsby@5.16.1_@types+node@24.13.3_babel-eslint@_3b3c4ea6f69555381d9d178f74c9c81f/node_modules/gatsby-plugin-use-query-params-v2/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.16.1_@types+node@24.13.3_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_r_914e64dfdac6e7d67048c390bc5a4ae7/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
